/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

/** `?mode=` values that mark an in-game or console webview. */
const GAME_MODES = ["game", "iosgame"];

/**
 * Is this one `mode` value a game mode?
 *
 * Case-insensitive, and callers treat a request as game mode when ANY of its `mode` values match:
 * game mode is the restrictive state (no way out of a webview), so an ambiguous request fails
 * towards it. The one rule shared by the server-side `isParamGameMode` in next-templates and the
 * client-side silent sign-in guard in next-hooks, so the two cannot disagree.
 */
export const isGameModeValue = (value: unknown): boolean =>
	typeof value === "string" && GAME_MODES.includes(value.toLowerCase());
